import React from "react";

const iconProps = {
	width: 18,
	height: 18,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"aria-hidden": true,
};

export const SettingsTabIcons = {
	account: (
		<svg {...iconProps}>
			<circle cx="12" cy="8" r="4" />
			<path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
		</svg>
	),
	security: (
		<svg {...iconProps}>
			<rect x="5" y="11" width="14" height="10" rx="2" />
			<path d="M8 11V8a4 4 0 018 0v3" />
		</svg>
	),
	preferences: (
		<svg {...iconProps}>
			<line x1="4" y1="6" x2="20" y2="6" />
			<line x1="4" y1="12" x2="20" y2="12" />
			<line x1="4" y1="18" x2="20" y2="18" />
			<circle cx="8" cy="6" r="2" fill="currentColor" stroke="none" />
			<circle cx="16" cy="12" r="2" fill="currentColor" stroke="none" />
			<circle cx="10" cy="18" r="2" fill="currentColor" stroke="none" />
		</svg>
	),
	verification: (
		<svg {...iconProps}>
			<rect x="4" y="5" width="16" height="14" rx="2" />
			<circle cx="12" cy="11" r="2.5" />
			<path d="M8 16h8" />
		</svg>
	),
	payment: (
		<svg {...iconProps}>
			<rect x="3" y="6" width="18" height="12" rx="2" />
			<path d="M3 10h18" />
		</svg>
	),
};
